module.exports = __webpack_public_path__ + "static/RiskOfRain1-844bef80078997299bae67ad4f2d0326.webp";